import schema from './schema.graphqls';
import { buildASTSchema } from 'graphql/utilities';

export const astSchema = buildASTSchema(schema);
